import { z } from 'zod';
import { REEL_CARD_STYLES, REEL_HEADING_CASES, REEL_PACES, REEL_SURFACES, REEL_TEXT_BACKINGS, REEL_WATERMARKS } from './reel-style.js';
/**
 * `reel_stylist` (E540, S540-7, spec 100 section 4.11): proposes a property's
 * video style from its brand and business. A proposal only: the person sees it
 * in the live preview and saves it through the brand settings, or not.
 */
export const reelStylistInputSchema = z.object({
    property_id: z.uuid(),
    /** Language of the reason (the person's UI language). */
    language: z.string().min(2).max(8),
});
export const REEL_STYLIST_LIMITS = { reasonMaxChars: 400 };
export const reelStylistOutputSchema = z.object({
    card: z.enum(REEL_CARD_STYLES),
    text_backing: z.enum(REEL_TEXT_BACKINGS),
    heading_case: z.enum(REEL_HEADING_CASES),
    pace: z.enum(REEL_PACES),
    surface: z.enum(REEL_SURFACES),
    watermark: z.enum(REEL_WATERMARKS),
    /** Why this style fits the business, in the input language; two or three sentences. */
    reason: z.string().min(1).max(REEL_STYLIST_LIMITS.reasonMaxChars),
});
//# sourceMappingURL=reel-stylist.js.map